import PropTypes from "prop-types";
import { memo } from "react";
import LuggageSummary from "app/pages/Booking/Quotation/Flight/LuggageSummary/LuggageSummary";

import "./MyFlightDetail.scss";
import Itinerary from "app/pages/.shared/Itinerary";

const MyFlightDetail = ({
	flight = {},
	luggageMaxCount = 0,
	lugaggeCount,
	flightOptionsFlightCode,
	flightOptions = {},
}) => {
	return (
		<div className="my-flight-detail">
			<div className="itinerary">
				<Itinerary
					inbound={flight.inbound}
					outbound={flight.outbound}
					disableDetails={true}
					displayRouteDetails={true}
					transportationType={flight?.type}
				/>
			</div>

			<LuggageSummary
				luggageMaxCount={luggageMaxCount}
				flight={flight}
				flightOptionsFlightCode={flightOptionsFlightCode}
				flightOptions={flightOptions}
				bookingLuggageCount={lugaggeCount}
				hideAddLuggageButton={true}
				transportationType={flight.type}
			/>
		</div>
	);
};

MyFlightDetail.propTypes = {
	flight: PropTypes.object,
	luggageMaxCount: PropTypes.number,
	lugaggeCount: PropTypes.number,
	flightOptionsFlightCode: PropTypes.string,
	flightOptions: PropTypes.object,
};

export default memo(MyFlightDetail);
